import UserDrawer from '@/pages/usersAdmin/UsersAdminDrawer.component'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/users/$userId')({
  component: () => <UserDrawer />,
  params: {
    parse: (params) => ({
      userId: z.number().int().parse(Number(params.userId)),
    }),
    stringify: ({ userId }) => ({ userId: `${userId}` }),
  },
  validateSearch: (search) => {
    return z
      .object({
        variant: z.enum(['edit', 'new']).default('edit'),
      })
      .parse(search)
  },
})
